import {TokenService} from '../TokenService';

import {useDialogCrup} from '../../../../shared/hooks/DialogCrup';

export const CreateIntrustCA = ({header, dataKey, refreshLazyData}) => {

  const {render, create} = useDialogCrup({
    header,
    dataKey,
    width: '45rem',
    fields: [
      {type: 'custom', className: 'md:col-12 text-center mb-3', body: (<img src="/images/intrustca-logo.jpg" alt=""/>)},
      {type: 'custom', className: 'md:col-12 text-center mb-0', body: <h4 className="mb-1">Thiết lập kết nối đến máy chủ ký số</h4>},
      {type: 'custom', className: 'md:col-12 text-center mb-5', body: <i>Thông tin kết nối do đơn vị cung cấp chứng thư số cấp</i>},
      {field: 'user', header: 'Tên đăng nhập', required: true, InputTextProps: {maxLength: 50}, className: 'md:col-6'},
      {field: 'passwordCer', header: 'Mật khẩu', type: 'Password', required: true, className: 'md:col-6'},
      {field: 'pin', header: 'Mã pin', type: 'Password', required: false, className: 'md:col-6'}
    ],
    createItem: (item) => {
      item.tokenType = 5;
      return TokenService.create(item);
    },
    refreshLazyData
  });

  return {render, open: create};

}